module.exports = __webpack_public_path__ + "media/images/check-41db73aae344e11ae6de96e78feabd04.svg";